import incentiveByAmount from '@/api/promotion/incentive-by-amount'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  store(context, data) {
    return incentiveByAmount.store(data)
  },
  update(context, { id, data }) {
    return incentiveByAmount.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await incentiveByAmount.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getFormViewModel(context, { params, index }) {
    let response = await incentiveByAmount.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}